/**
 * セッション (ログイン状態) の管理。
 *
 * トークンの保存先はプラットフォームによって異なる
 * (Web: localStorage / React Native: AsyncStorage や SecureStore) ため、
 * 保存の実装は TokenStorage として外から注入する。
 */
/** 保存しない (毎回ログアウト扱いになる) 実装。テストや SSR の既定値に使う */
export const memoryTokenStorage = () => {
    let value = null;
    return {
        get: () => value,
        set: (token) => {
            value = token;
        },
        remove: () => {
            value = null;
        },
    };
};
/**
 * Web 用の実装。
 * プライベートブラウジングなどで localStorage が使えない場合は
 * 例外を投げずにメモリ保存へフォールバックする。
 */
export const webTokenStorage = (key = "spli.auth.token") => {
    const fallback = memoryTokenStorage();
    const available = () => {
        try {
            return typeof globalThis.localStorage !== "undefined";
        }
        catch {
            return false;
        }
    };
    return {
        get: () => {
            if (!available())
                return fallback.get();
            try {
                return globalThis.localStorage.getItem(key);
            }
            catch {
                return fallback.get();
            }
        },
        set: (token) => {
            if (!available())
                return fallback.set(token);
            try {
                globalThis.localStorage.setItem(key, token);
            }
            catch {
                fallback.set(token);
            }
        },
        remove: () => {
            if (!available())
                return fallback.remove();
            try {
                globalThis.localStorage.removeItem(key);
            }
            catch {
                fallback.remove();
            }
        },
    };
};
const RECENT_LIMIT = 20;
export function createRecentGroupStore(key = "spli.recent.groups", storage) {
    const backing = storage ??
        (typeof globalThis.localStorage !== "undefined" ? globalThis.localStorage : undefined);
    const read = () => {
        if (!backing)
            return [];
        try {
            const raw = backing.getItem(key);
            if (!raw)
                return [];
            const parsed = JSON.parse(raw);
            return Array.isArray(parsed) ? parsed : [];
        }
        catch {
            return [];
        }
    };
    const write = (groups) => {
        if (!backing)
            return;
        try {
            backing.setItem(key, JSON.stringify(groups.slice(0, RECENT_LIMIT)));
        }
        catch {
            // 保存できなくても致命的ではないので無視する
        }
    };
    return {
        list: () => read().sort((a, b) => (a.openedAt < b.openedAt ? 1 : -1)),
        remember: (group, now = new Date()) => {
            const others = read().filter((g) => g.shareToken !== group.shareToken);
            write([{ ...group, openedAt: now.toISOString() }, ...others]);
        },
        forget: (shareToken) => {
            write(read().filter((g) => g.shareToken !== shareToken));
        },
    };
}
//# sourceMappingURL=session.js.map